import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { User } from '../../shared/entities/user/user';
import { LoadingService } from '../../shared/services/loading.service';
import { UsersService } from '../../shared/services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-user-password-dialog',
  templateUrl: './user-password-dialog.component.html',
  styleUrls: ['./user-password-dialog.component.scss']
})
export class UserPasswordDialogComponent
  implements EditDialogInstance {

    userPasswordForm: FormGroup;
    user: User;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public loadingService: LoadingService
  ) {
    if (this.config.data) {
      this.user = this.config.data;
    }

    this.userPasswordForm = new FormGroup({});
    // add form controls
    this.userPasswordForm.addControl('password', new FormControl(undefined, Validators.required));
    this.userPasswordForm.addControl('updatePassword', new FormControl(false));
    
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    console.log(this.userPasswordForm.value);
    // {password: 'sadfadsf', updatePassword: true}
    this.loadingService.setLoading(true);
    let requiredActions = this.userPasswordForm?.value?.updatePassword ? ['UPDATE_PASSWORD'] : [];
    let password = this.userPasswordForm?.value?.password;
    this.userService.resetPassword(
      this.user.id,
      password,
      requiredActions,
      () => {
        this.loadingService.setLoading(false);
        this.ref.close(true);
      }
    );
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.userPasswordForm;
  }

}
